// extracted by mini-css-extract-plugin
export default {"lottieAnimationBox":"index_lottieAnimationBox_3S07e","lottieAnimation":"index_lottieAnimation_3olWE"};